import React from 'react';
import { Tooltip } from '@mui/material';
import { format, isToday, isYesterday } from 'date-fns';

const MiniChatItem = ({
  chat,
  isSelected,
  onChatSelect,
  instruments
}) => {
  const formatChatName = (chatName) => {
    if (!chatName) return 'Untitled';
    return chatName.replace('_', '/');
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) return '';

    try {
      if (isToday(date)) {
        return format(date, 'h:mm a');
      }
      if (isYesterday(date)) {
        return 'Yesterday';
      }
      return format(date, 'MMM d');
    } catch (error) {
      return '';
    }
  };

  const getProvider = () => {
    const formattedName = chat.chat_name?.replace('/', '_');
    for (const category of Object.values(instruments || {})) {
      if (formattedName in category) {
        return category[formattedName].provider;
      }
    }
    return chat.provider || 'Unknown';
  };

  // Create abbreviation from instrument name (EUR_USD -> EU, BTCUSDT -> BT)
  const getAbbreviation = () => {
    const name = chat.chat_name || '';
    if (name.includes('_')) {
      // Forex style: EUR_USD -> EU
      return name.split('_').map(p => p.charAt(0)).join('');
    }
    // Crypto style: BTCUSDT -> BT
    return name.slice(0, 2).toUpperCase();
  };

  const tooltipContent = (
    <div className="mini-chat-tooltip">
      <div style={{ fontWeight: 500 }}>{formatChatName(chat.chat_name)}</div>
      <div className="tooltip-date">
        {getProvider()} • {formatDate(chat.updated_at)}
      </div>
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="right"
      enterDelay={300}
      arrow
    >
      <div
        className={`mini-chat-item ${isSelected ? 'selected' : ''}`}
        onClick={() => onChatSelect(chat)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && onChatSelect(chat)}
        aria-label={formatChatName(chat.chat_name)}
      >
        <span className="mini-chat-letter">{getAbbreviation()}</span>
      </div>
    </Tooltip>
  );
};

export default MiniChatItem;
